const TrashSvg = (): JSX.Element => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M19.6667 6.66602L5 6.66602"
        stroke="#8083A0"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.332 10.666V15.9993"
        stroke="#8083A0"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.332 10.666V15.9993"
        stroke="#8083A0"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.332 6.66602V19.3327C18.332 19.5095 18.2618 19.6791 18.1368 19.8041C18.0117 19.9291 17.8422 19.9993 17.6654 19.9993H6.9987C6.82189 19.9993 6.65232 19.9291 6.52729 19.8041C6.40227 19.6791 6.33203 19.5095 6.33203 19.3327V6.66602"
        stroke="#8083A0"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.6667 6.66667V5.33333C15.6667 4.97971 15.5262 4.64057 15.2761 4.39052C15.0261 4.14048 14.687 4 14.3333 4H10.3333C9.97971 4 9.64057 4.14048 9.39052 4.39052C9.14048 4.64057 9 4.97971 9 5.33333V6.66667"
        stroke="#8083A0"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default TrashSvg;
